export enum WidgetTypes {
  State = 'State',
  StateLeague = 'StateLeague',
  League = 'League',
  District = 'District',
  School = 'School',
}
